export default "__VITE_ASSET__D4_sx9rS__"